(function () {
  angular
    .module("akitabox.desktop.asset.organizationList")
    .controller(
      "OrganizationAssetListController",
      OrganizationAssetListController
    );

  /* @ngInject */
  function OrganizationAssetListController(
    // Angular
    $scope,
    $timeout,
    $location,
    $q,
    // Constants
    EVENT_ASSET_CREATE,
    // Dialogs
    ExportDialog,
    // Services
    AssetService,
    OrganizationService,
    PinService,
    ToastService,
    // Filtering
    FilterBarManager,
    ManagedModelFieldFilter,
    ManagedBuildingFilter,
    ManagedFilterHelpers,
    // Resolve
    decommissioned
  ) {
    var self = this;

    var organization = OrganizationService.getCurrent();
    // Attributes
    self.organization = organization;
    self.assets = null;
    self.decommissioned = decommissioned;
    self.fabActions = getFabActions();
    self.activeFilters = null;

    // Functions
    self.changeFilters = changeFilters;
    self.fetchAssets = fetchAssets;
    self.fetchAllAssets = fetchAllAssets;

    // ------------------------
    //   Events
    // ------------------------

    $scope.$on(EVENT_ASSET_CREATE, onAssetCreate);

    self.filterBarManager = new FilterBarManager({
      onFilterChange: function () {
        var query = self.filterBarManager.getQuery();
        // apply the static ?decommissioned=${decommissioned} portion of the query
        query.decommissioned = decommissioned;

        // update the list
        changeFilters(query);
      },
    });

    const show_fca = self.organization && self.organization.show_fca;

    var nameConfig = new ManagedModelFieldFilter(self.filterBarManager, {
      displayName: "Name",
      queryField: "name",
    });

    var placedOnFloorConfig = new ManagedModelFieldFilter(
      self.filterBarManager,
      {
        displayName: "Placed on Floor Plan",
        queryField: "percentX",
        inputType: "boolean",
        modelValueToFilterValue: function (placedOnFloor) {
          return placedOnFloor ? "$ne,null" : "null";
        },
        modelValueToChipText: function (placedOnFloor) {
          return placedOnFloor ? "Yes" : "No";
        },
        filterValueToModelValue: function (queryParameter) {
          return [queryParameter === "$ne,null"];
        },
      }
    );

    var buildingConfig = new ManagedBuildingFilter(self.filterBarManager, {
      getOrganizationId: function () {
        return self.organization._id;
      },
    });

    self.filterBarManager.addFilterConfiguration(nameConfig);
    if (show_fca) {
      var totalCostConfig = new ManagedModelFieldFilter(self.filterBarManager, {
        displayName: "Total Cost",
        queryField: "cost",
        inputType: "float-range",
        modelValueToChipText:
          ManagedFilterHelpers.numberRangeModelValueToChipText,
        modelValueToFilterValue:
          ManagedFilterHelpers.numberRangeModelValueToFilterValue,
        filterValueToModelValue:
          ManagedFilterHelpers.numberRangeFilterValueToModelValue,
      });
      self.filterBarManager.addFilterConfiguration(totalCostConfig);
    }
    self.filterBarManager.addFilterConfiguration(placedOnFloorConfig);
    self.filterBarManager.addFilterConfiguration(buildingConfig);

    self.filterInitPromise = self.filterBarManager.applyQuery(
      $location.search()
    );

    // ------------------------
    //   Private Functions
    // ------------------------

    function getFabActions() {
      return [
        {
          icon: "get_app",
          label: "Export",
          action: exportAssets,
        },
      ];
    }

    function exportAssets() {
      var locals = {
        route: AssetService.buildOrganizationListRoute(organization._id),
        filters: self.activeFilters,
        excelOnly: true,
      };
      ExportDialog.show({ locals: locals }).catch(ToastService.showError);
    }

    /**
     * Handle asset creation event
     *
     * @param {Event}   $event    Angular event
     * @param {Asset[]} assets    List of new assets
     */
    function onAssetCreate($event, assets) {
      // We can only create one asset at a time
      var asset = assets[0];
      PinService.includePinType(asset.building, [asset]).then(function (
        results
      ) {
        if (!self.assets) {
          self.assets = [];
        }
        self.assets.unshift(results[0]);
        $timeout(function () {
          $scope.$broadcast("list:refreshClickEvents");
        });
      });
    }

    // ------------------------
    //   Public Functions
    // ------------------------

    function fetchAssets(skip, limit) {
      // Add status to url if not preset in active filters
      if (
        self.activeFilters &&
        !Object.prototype.hasOwnProperty.call(
          self.activeFilters,
          "decommissioned"
        )
      ) {
        $location.search("decommissioned", decommissioned);
      }

      var doFetch = function () {
        var params;
        params = {
          skip: skip,
          limit: limit,
          include_values: true,
          decommissioned: decommissioned,
        };

        var filters = angular.extend({}, params, self.activeFilters);

        const setAssets = function (assets) {
          let asset = updateAssetsProps(assets);
          self.assets = angular.isArray(self.assets)
            ? self.assets.concat(asset)
            : asset;
          return assets.length;
        };

        return AssetService.getByBFFOrganization(
          self.organization._id,
          filters
        ).then(setAssets);
      };
      return $q.resolve(self.filterInitPromise).then(doFetch);
    }

    function updateAssetsProps(assets) {
      return assets.map((asset) => {
        const building = asset.building;
        if (building && building._id && building._id) {
          asset.building = building._id;
          asset.building_name = building.name;
        }
        if (asset.room) asset.room.value = asset.room._id;
        if (asset.level) asset.level.value = asset.level._id;
        return {
          ...asset,
        };
      });
    }

    function fetchAllAssets(limit) {
      // Add status to url if not preset in active filters
      if (
        self.activeFilters &&
        !Object.prototype.hasOwnProperty.call(
          self.activeFilters,
          "decommissioned"
        )
      ) {
        $location.search("decommissioned", decommissioned);
      }

      var doFetch = function () {
        var params;
        params = {
          skip: 0,
          limit: limit,
          include_values: true,
          decommissioned: decommissioned,
        };

        var filters = angular.extend({}, params, self.activeFilters);

        const setAssets = function (assets) {
          let asset = updateAssetsProps(assets);
          self.assets = angular.isArray(self.assets)
            ? self.assets.concat(asset)
            : asset;
          return assets.length;
        };

        return AssetService.getByBFFOrganization(
          self.organization._id,
          filters
        ).then(setAssets);
      };
      return $q.resolve(self.filterInitPromise).then(doFetch);
    }

    function changeFilters(activeFilters) {
      $location.search(activeFilters).replace();
      self.activeFilters = activeFilters;
      self.assets = null;
      $scope.$broadcast("list:refresh");
    }
  }
})();
